module.exports = __webpack_public_path__ + "ccbf3327d6a70287e455a9639dc66c9a.jpg";